import { Stack, styled } from '@mui/material';

export const Root = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
  padding: theme.spacing(2, 4),
  height: '100%',
  backgroundColor: theme.palette.common.white,
}));
